<template>
<div>
  <vs-card class="cstm_vx_card">
    <vs-row vs-justify="space-between" slot="header">
      <h4>Email</h4>
      <vs-button
     v-if="checkEditPermission()"
        type="border"
        color="primary"
        style="font-size: 13.8px; padding: 7px; float: right;"
        @click="addpopup = true"
      >
        Add
      </vs-button>
      </vs-row>
      <div class="vx-row">
        <vs-table :data="emailAvailability" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="name">Email</vs-th>
            <vs-th sort-key="status" style="width: 250px;">Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(item, indextr) in data">
              <vs-td :data="data[indextr].email">
                {{ data[indextr].email }}
              </vs-td>
              <vs-td :data="data[indextr]">
                <vs-row vs-type="flex">
                  <vs-checkbox :checked="data[indextr].default" @change="handlePhonedefault(indextr)">Mark Default</vs-checkbox>
                  <vs-button v-if="checkEditPermission()" color="primary" type="filled" icon="edit" class="mr-2" @click="handleedit(indextr)"/>
                  <vs-button v-if="checkDeletePermission()" type="filled" :disabled ="data[indextr].default === 1" @click="remove(indextr)" icon="delete" color="danger"/>
                </vs-row>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>


    <vs-popup classContent="popup-example"  title="Delete" :active.sync="deletepopup">
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>


    <vs-popup classContent="popup-example"  title="Add Email" :active.sync="addpopup">
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required|email'" name="email" v-model="email" class="custom_Input" label="Email" icon-pack="feather" icon="icon-edit" icon-after style="width:100%;" />
              <span v-show="errors.has('add.email')" class="text-danger">{{ errors.first('add.email') }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSaveEmail">Save</vs-button>
        <vs-button type="border" color="danger" @click="phoneNumberAddpopup  = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>


    <vs-popup classContent="popup-example"  title="Edit Email" :active.sync="editpopup">
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input v-validate="'required|email'" name="email" v-model="edit" class="custom_Input" label="Email" icon-pack="feather" icon="icon-edit" icon-after style="width:100%;" />
            <span v-show="errors.has('edit.email')" class="text-danger">{{ errors.first('edit.email') }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdateEmail">Save</vs-button>
        <vs-button type="border" color="danger" @click="editpopup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>
</div>
</template>
<script>
import {  TeacherUpdate } from '@/api/teacher'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
export default {
  name: 'email',
  props: {
    emailProps: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  data () {
    return {
      addpopup: false,
      deletepopup:false,
      editpopup: false,
      email: null,
      edit: null,
      editIndex: null,
      deleteindex: false,
      emailAvailability:[]
    }
  },
  /* computed: {
    emailAvailability: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }, */
  watch:{
    emailProps:{
      deep:true,
      immediate:true,
      handler () {
        this.emailAvailability = this._.cloneDeep(this.emailProps)
      }
    }
  },
  methods: {
    handlePhonedefault (index) {
      this.emailAvailability = this.emailAvailability.map(item => {
        item.default = 0
        return item
      })
      this.emailAvailability[index].default = 1
      this.editIndex =  index
      this.edit = this.emailAvailability[index].email
      this.handleUpdateEmail()
    },
    handleSaveEmail () {
      this.$validator.validateAll('add').then(result => {
        if (result) {
          const payload = {
            email: this.email,
            default: 0
          }
          this.emailAvailability.push(payload)
          this.handleEmailsave()

         
        }
      })
    },
    handleedit (index) {
      
      this.editpopup = true
      this.edit = this.emailAvailability[index].email
      this.editIndex =  index
    },
    handleUpdateEmail () {
      this.$validator.validateAll('edit').then(result => {
        if (result) {
          this.emailAvailability[this.editIndex].email = this.edit
          this.handleEmailsave()

        }
      })
    },
    handleDelete () {
      this.emailAvailability.splice(this.deleteindex, 1)
      this.handleEmailsave()
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    async handleEmailsave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            email: this.emailAvailability
          }
        }
        const {data} = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )
        // this.setAfterUpdate(data)
        this.addpopup = false
        this.email = null
        this.deletepopup = false
        this.editpopup  = false


        this.$emit('setAfterUpdate', data)
        // this.fetchTeacherDetails(this.$route.params.teacher_id)
        // this.bioEditPopup = false
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')

      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
 
}
</script>
